import { captureExceptionWithAttributes } from "@tracewayapp/svelte";

import { shouldRedirect } from "$lib/paraglide/runtime.js";

/**
 * The site is prerendered (adapter-static), so `handle` in `hooks.server.js`
 * only runs at build time. In production there is no server to issue the
 * locale redirect, so we do it on the client before the app starts.
 *
 * @type {import("@sveltejs/kit").ClientInit}
 */
export const init = async () => {
  const { pathname } = window.location;

  if (pathname.startsWith("/api")) {
    return;
  }

  try {
    // No `url` argument on purpose: passing one makes paraglide resolve the
    // locale *from the URL*, which can never produce a redirect. Omitting it
    // makes it use the configured strategies (localStorage, cookie,
    // preferredLanguage, url, baseLocale) against `window.location`.
    const decision = await shouldRedirect();

    if (decision.shouldRedirect && decision.redirectUrl) {
      window.location.replace(decision.redirectUrl.href);
    }
  } catch {
    // never block app start on locale detection
  }
};

/** @type {import("@sveltejs/kit").HandleClientError} */
export function handleError({ error, event }) {
  captureExceptionWithAttributes(error, {
    route: event.route?.id ?? event.url.pathname,
  });
  return { message: "Something went wrong" };
}
